"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EAuthenticateStatus = void 0;
let EAuthenticateStatus = exports.EAuthenticateStatus = /*#__PURE__*/function (EAuthenticateStatus) {
  EAuthenticateStatus["Initial"] = "initial";
  EAuthenticateStatus["Loading"] = "loading";
  EAuthenticateStatus["Succeed"] = "succeed";
  EAuthenticateStatus["Failed"] = "failed";
  return EAuthenticateStatus;
}({});